import * as React from 'react';
import { isVoipEnabled, userSession } from 'state/session';
import { myCameraStream } from 'state/video';
import logger from 'utils/log';
import { tenantConfig } from 'utils/tenant';
import { voipRtcConnection } from 'utils/ui/rtc';

const useVoipConnections = () => {
  userSession().useState();
  tenantConfig().useState();
  myCameraStream().useState();

  const { remoteConnections } = voipRtcConnection?.store?.useState() || { remoteConnections: {} };
  const connections = Object.values(remoteConnections);
  const [activeConnectionId, setActiveConnectionId] = React.useState<string>('');

  React.useEffect(() => {
    if (connections.length > 0 && voipRtcConnection) {
      logger.log('[VOIP] SingularVOIP - Publishing user stream...');
      voipRtcConnection.publish();
    }
  }, [connections.length]);

  React.useEffect(() => {
    if (connections.length > 0) {
      setActiveConnectionId((prev) => {
        const newActive = connections.find((remote) => {
          return remote.isActiveSpeaker || remote.lastActiveSpeaker;
        });
        if (newActive && newActive.connectionId !== prev) {
          return newActive.connectionId;
        }
        return prev || connections[0].connectionId;
      });
    } else {
      setActiveConnectionId('');
    }
  }, [connections]);

  return {
    remoteConnections,
    activeConnectionId: activeConnectionId,
    canShowVoip: tenantConfig().isAllowed('voip') && isVoipEnabled(),
  };
};

export default useVoipConnections;
